import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { WelcomeComponent } from './welcome.component';
import { WelcomeAdminComponent } from './welcome-admin.component';
import { HeaderModule } from '../header/header.module';
import { BigNumberedListItemComponent } from './big-numbered-list-item/big-numbered-list-item.component';

@NgModule({
  declarations: [
    WelcomeComponent,
    WelcomeAdminComponent,
    BigNumberedListItemComponent,
  ],
  providers: [],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    HeaderModule
  ],
})
export class WelcomeModule {}
